<template>
  <div id="image-gallery-page">
    <ParallaxHeader :headline="'Image Gallery'" :slogan="''"/>
    <v-container fluid grid-list-xl>
      <v-layout row wrap justify-center>
        <v-flex xs12 lg8 xl6>
          <!-- <ImageGallery :thumbnail="gallery"/> -->
          <BuzzGallery :images="gallery"/>
        </v-flex>
      </v-layout>
    </v-container>
  </div>
</template>

<script>
import ParallaxHeader from '@/components/ParallaxHeader'
// import ImageGallery from '@/components/ImageGallery'
import BuzzGallery from '@/components/BuzzGallery'
import Api from '@/api'

export default {
  data () {
    return {
      gallery: []
    }
  },
  beforeMount () {
    this.getGalleryData()
  },
  components: {
    ParallaxHeader,
    // ImageGallery
    BuzzGallery
  },
  methods: {
    getGalleryData () {
      // console.log(projectID)
      const path = '/image-gallery'
      const auth = {
        username: this.authUsername,
        password: this.authPassword
      }
      Api.get(path, auth)
        .then(response => {
          if (response.data.status === 0) {
            // console.log(response.data.imagegallery[0].project_details)
            response.data.imagegallery.forEach((el) => {
              this.gallery.push({ 'image': 'https://cdnblobendpoint.azureedge.net/bezzina-static/img/' + el.name, 'project': el.project.name })
            })
          } else {
            this.$swal(response.data.message)
          }
        })
        .catch(error => {
          this.$swal({
            'type': 'error',
            'title': error.toString().substring(0, 100)
          })
        })
    }
  }
}
</script>

<style scoped>
.card {
  margin-bottom: 10px;
}
#image-gallery-page {
  font-family: 'Lato', sans-serif;
}
#page-name {
  font-size: 3.5vmax;
  font-family: 'Vollkorn', serif;
}
.container {
  /*min-height: 58vh;*/
}
</style>


// WEBPACK FOOTER //
// src/pages/ImageGalleryPage.vue